<script lang="ts">
  import { fly } from "svelte/transition";
  import Popper from "../../overlay/Popper.svelte";

  export let tooltip: string | false = false;

  let open = false;
  let element: HTMLElement;
</script>

<svelte:body
  on:click={() => {
    if (open) open = false;
  }} />

<span bind:this={element} on:mouseenter={() => (open = true)} on:mouseleave={() => (open = false)}><slot /></span><button on:click|stopPropagation={() => (open = !open)} tabindex="0">?</button>

{#if tooltip != false}
  <Popper input={element} {open} placement="top">
    <div class="tooltip show" transition:fly={{ duration: 200, y: 5, opacity: 0 }}>
      {tooltip}
    </div>
  </Popper>
{/if}

<style lang="scss">
  button {
    vertical-align: text-top;
    margin-left: 0.5em;
    color: #000;
    background-color: rgb(0 0 0 / 15%);
    border: none;
    width: 14px;
    height: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    font-size: 12px;
    text-decoration: none;
    cursor: help;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    overflow: hidden;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    //
    margin-bottom: 5px;
    padding: 7px;
    width: 200px;
    min-width: min-content;
    max-width: calc(100vw - 2rem);
    border-radius: 10px;
    background-color: hsla(0, 0%, 20%, 0.9);
    color: #fff;
    text-align: center;
    font-weight: 300;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: 0px;
    transition: 0.2s ease-out;
    box-shadow: 0px 2px 35px -2px rgb(0 0 0 / 15%);
    //
    pointer-events: none;

    // arrow
    &:after {
      position: absolute;
      top: 100%;
      left: 50%;
      width: 0;
      border-top: 5px solid #000;
      border-top: 5px solid hsla(0, 0%, 20%, 0.9);
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      content: " ";
      font-size: 0;
      line-height: 0;
    }
  }
</style>
